export default "__VITE_ASSET__29e77163__"